import {Component} from '@angular/core';

@Component({
  selector: 'gatewee-element-spinner',
  templateUrl: './element-spinner.component.html',
  styleUrls: ['./element-spinner.component.css'],
  standalone: false,
})
export class ElementSpinnerComponent {}
